import React from 'react';
import { Provider } from 'react-redux';
import { configureStore } from './redux/store';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'react-hot-toast';

import App from './App';

const originalConsoleError = console.error;
console.error = (...args) => {
  const firstArg = args[0];

  if (typeof firstArg === 'string' && firstArg.includes('ResizeObserver loop completed')) {
    console.warn('Ignoring ResizeObserver warning:', firstArg);
    return;
  }

  originalConsoleError(...args);
};

// Mencegah error ResizeObserver loop
if (typeof window !== 'undefined' && window.ResizeObserver) {
  const _ResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          if (callback) callback(entries, observer);
        });
      });
    }
  };
}


const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <Provider store={configureStore({})}>
    <App />
    <Toaster />
  </Provider>
);
